import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import jsx1 from './assets/images/jsx1.png';
import jsx2 from './assets/images/jsx2.png';
import jsx3 from './assets/images/jsx3.png';
import jsx4 from './assets/images/jsx4.png';


const ReactLesson4 = () => {

  const [language, changeLanguage] = useState("jsx");
    const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      const name = 'Sunday Nwachukwu';
      const greeting = <h1>Hello, {name}</h1>

      `
    );
    const code1 = (
      'text',
      `
      function Greeting(props) {
        return <h1>Hello, {props.name}</h1>;
      }

      `
    );
    const code2 = (
      'text',
      `
      const element = <img src={image} alt="An image" />;


      `
    );
    const code3 = (
      'text',
      `
      const element = react.createElement('h1', null, 'Hello, world!);


      `
    );


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3>Understanding JSX</h3>
     <p>Before we create our first React Component, let's first understand what JSX is and how it works as we will be dealing with it for the most part of this course.</p>
     <p>JSX (JavaScript XML) is a syntax extension used in React that allows developers to write HTML-like code directly within JavaScript. It's a key feature of React that simplifies the process of creating and managing user interfaces.</p>
     <h4 class="text-dark">Key Points about JSX:</h4>
     <ol class="list-group list-group-numbered">
     <li class="list-group-item"><strong>Combining JavaScript and HTML:</strong> JSX enables the integration of HTML-like code directly into JavaScript, allowing developers to write UI components using a syntax that closely resembles HTML/XML.</li>
     <li class="list-group-item"><strong>JavaScript Expressions:</strong> JSX allows embedding JavaScript expressions within curly braces {}. This allows dynamic content rendering, variable insertion, function calls, and other JavaScript expressions within the markup.
     <ol class="mb-2">
     <CopyBlock
                        language={"react"}
                        text={code} // Ensure 'code' variable is defined
                        showLineNumbers={lineNumbers} // Ensure 'lineNumbers' variable is defined
                        theme={dracula} // Ensure 'dracula' variable is defined
                        wrapLines={true}
                        codeBlock
                      />     </ol>
     </li>
     <li class="list-group-item"><strong>Component Creation:</strong> JSX allows the creation of React components by using tags that resemble HTML/XML elements. These components can be user-defined or built-in React components.
     <ol class="mb-2">
     <CopyBlock
                        language={"react"}
                        text={code1}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />     </ol>
     </li>
     <li class="list-group-item"><strong>Attributes and Props:</strong> JSX supports attributes similar to HTML attributes and allows passing props (properties) to components using attributes.
     <ol>
     <CopyBlock
                        language={"react"}
                        text={code2}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />         <li>We shall see how to properrly add image in a separate lesson.</li>
     </ol>
     </li>
     <li class="list-group-item"><strong>Syntactic Sugar:</strong> JSX is not valid JavaScript on its own. It is a syntactic sugar that gets transformed into standard JavaScript by tools like Babel before being interpreted by browsers. The transformed code is in the form of React.createElement() calls.
     <ol>
     <CopyBlock
                        language={"react"}
                        text={code3}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />     </ol>
     </li>
    </ol>
    <h3><strong>Benefits of Using JSX in React:</strong></h3>
      <ol class="list-group list-group-numbered mb-4">
          <li class="list-group-item"><strong>Integration of Logic and Markup:</strong> JSX enables the integration of JavaScript logic directly into the UI code, making it simpler to handle dynamic content and logic within components.</li>
          <li class="list-group-item"><strong>Readability and Maintainability:</strong> JSX improves code readability by allowing developers to write UI components in a format similar to HTML, making it easier to understand and maintain.</li>
          <li class="list-group-item"><strong>Tooling Support:</strong> JSX is well-supported by various developer tools and IDEs, providing syntax highlighting, linting, and error checking for improved development experience.</li>
          <li class="list-group-item"><strong>Declarative UI Design:</strong> JSX follows a declarative approach, where developers describe what the UI should look like based on the current state, allowing React to efficiently update the UI when the state changes.</li>
      </ol>
      <h3>Summary</h3>
      <p>JSX is a robust and user-friendly React syntax extension that combines the advantages of JavaScript with the comfort of HTML/XML-like syntax to simplify the process of creating user interfaces. It is essential to the development of dynamic, reusable, and maintainable components for React applications.</p>
    </div>



    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson4
